import Component from 'vue-class-component'
import { Prop, Vue } from 'vue-property-decorator'
import { recordFinishTime } from '../../../../service/platform'
import { ExtraData, RecordData, SendMessageData, TaskInstance } from '../../types/task'

@Component
export class OperationMixin extends Vue {
  @Prop() public data!: TaskInstance
  @Prop() public sendMessageData!: SendMessageData
  @Prop() public extraData!: ExtraData

  public loading = false

  public close(reload) {
    this.$emit('setLayout', 'close', reload)
  }

  public clickReturn() {
    this.$emit('setLayout', 'return')
  }

  public async getFinishTime(data: RecordData) {
    await recordFinishTime(data)
  }

  private onLoading(val: boolean) {
    this.loading = val
  }
}
